import { DataTable, EmptyState, type Spalte } from '../../muster';

/**
 * Die Lösungsarten mit ihren Vorlagen (Batch 7).
 *
 * Titel- und Textvorlage sind der Ausgangstext, aus dem die
 * Lösungsableitung eine Anweisung baut (Platzhalter werden dort ersetzt) —
 * hier stehen sie ungefüllt, als das, was gepflegt wird.
 */
export function Loesungsarten({ loesungsarten }: { loesungsarten: any[] }) {
  const spalten: Spalte<any>[] = [
    {
      schluessel: 'schluessel', titel: 'Schlüssel', immerSichtbar: true,
      breite: '170px', wert: (l) => l.schluessel,
    },
    { schluessel: 'bezeichnung', titel: 'Bezeichnung', wert: (l) => l.bezeichnung },
    {
      schluessel: 'zustaendig', titel: 'Zuständig', breite: '140px',
      wert: (l) => l.zustaendig,
      inhalt: (l) => <span className="schwach">{l.zustaendig}</span>,
    },
    { schluessel: 'aufwand', titel: 'Aufwand', breite: '110px', wert: (l) => l.aufwand },
    {
      schluessel: 'sicherheit', titel: 'Sicherheit', breite: '120px',
      wert: (l) => l.sicherheit,
    },
    {
      schluessel: 'titelvorlage', titel: 'Titelvorlage',
      wert: (l) => l.titelvorlage,
      inhalt: (l) => <span style={{ fontSize: 12 }}>{l.titelvorlage}</span>,
    },
  ];

  return (
    <DataTable
      name="Lösungsarten"
      spalten={spalten}
      zeilen={loesungsarten ?? []}
      schluessel={(l) => l.schluessel}
      ausfuhr
      leer={(
        <EmptyState
          titel="Keine Lösungsart gepflegt."
          erklaerung={'Ohne Lösungsart entsteht keine Anweisung — die Ableitung hätte '
            + 'keinen Text, aus dem sie eine bauen könnte.'}
        />
      )}
    />
  );
}
